export default __webpack_public_path__ + "static/media/transferAction.24255b0e.svg";